// extracted by mini-css-extract-plugin
export default {"manageSubscriptionDialog":"styles_manageSubscriptionDialog__N7Mmc","manageSubscriptionDialogWidget":"styles_manageSubscriptionDialogWidget__7t+2G"};